import {
  Button,
  ButtonProps,
  Collapse,
  CollapseProps,
  Drawer,
  Space,
} from 'antd'

const DrawerFilter = ({
  isFilterDrawerOpen,
  setIsFilterDrawerOpen,
  onClearAll,
  onApply,
  items,
  buttonSize,
  title,
  applyTitle,
  clearTitle,
}: {
  isFilterDrawerOpen: boolean
  setIsFilterDrawerOpen: (isFilterDrawerOpen: boolean) => void
  onClearAll: () => void
  onApply: () => void
  items: CollapseProps['items']
  buttonSize: ButtonProps['size']
  title: string
  applyTitle: string
  clearTitle: string
}) => {
  return (
    <Drawer
      title={title}
      placement="left"
      onClose={() => setIsFilterDrawerOpen(false)}
      open={isFilterDrawerOpen}
      extra={
        <Space>
          <Button size={buttonSize} onClick={onClearAll}>
            {clearTitle}
          </Button>
          <Button type="primary" size={buttonSize} onClick={onApply}>
            {applyTitle}
          </Button>
        </Space>
      }
    >
      <Collapse
        className="search-filters-collapse"
        size="large"
        accordion
        items={items}
        bordered={false}
      />
    </Drawer>
  )
}

export default DrawerFilter
